import React from "react";

/**
 * Small status pill. Colour carries the triage; the label carries the detail.
 *
 * The tint and the border both derive from the status colour (via --tint, which differs between
 * light and dark) so a pill keeps the same weight against either background.
 */
export const Tag: React.FC<{ tone: "safe" | "warn" | "crit" | "mute" | "accent"; children: React.ReactNode }> = ({
    tone,
    children,
}) => {
    const cls = {
        safe: "bg-[color-mix(in_srgb,var(--safe)_calc(var(--tint)*100%),transparent)] text-[var(--safe)] border-[color-mix(in_srgb,var(--safe)_45%,transparent)]",
        warn: "bg-[color-mix(in_srgb,var(--warn)_calc(var(--tint)*100%),transparent)] text-[var(--warn)] border-[color-mix(in_srgb,var(--warn)_45%,transparent)]",
        crit: "bg-[color-mix(in_srgb,var(--crit)_calc(var(--tint)*100%),transparent)] text-[var(--crit)] border-[color-mix(in_srgb,var(--crit)_45%,transparent)]",
        accent: "bg-[color-mix(in_srgb,var(--accent)_calc(var(--tint)*100%),transparent)] text-[var(--accent)] border-[color-mix(in_srgb,var(--accent)_50%,transparent)]",
        mute: "bg-[var(--surface-2)] text-[var(--muted)] border-transparent",
    }[tone];
    return (
        <span
            className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1.5 text-[12.5px] font-semibold ${cls}`}
        >
            {children}
        </span>
    );
};
